import { COLORS, LAYOUT, TYPOGRAPHY } from '../../constants';

// Add CSS animation for spinner
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
if (!document.head.querySelector('style[data-spinner]')) {
  styleSheet.setAttribute('data-spinner', 'true');
  document.head.appendChild(styleSheet);
}

export const styles = {
  // Main container
  container: {
    minHeight: '100vh',
    backgroundColor: COLORS.grayLight,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: `${LAYOUT.spacing.xxl} ${LAYOUT.spacing.lg}`,
  },

  // Loading state
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    color: COLORS.text.secondary
  },

  spinner: {
    width: '40px',
    height: '40px',
    border: `4px solid ${COLORS.grayLight}`,
    borderTop: `4px solid ${COLORS.primary}`,
    borderRadius: LAYOUT.borderRadius.full,
    animation: 'spin 1s linear infinite',
    marginBottom: LAYOUT.spacing.lg
  },

  loadingText: {
    ...TYPOGRAPHY.body,
    color: COLORS.text.secondary
  },

  // Content wrapper
  contentWrapper: {
    width: '100%',
    maxWidth: '900px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
};